module.exports = __webpack_public_path__ + "img/courier.f0ba0e76.svg";